<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Clearing.MarkBill')"
      width="450px"
      class="sign-billing-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form label-width="100px" label-position="right">
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('Clearing.AnnotationDate')">
            <el-date-picker
              v-model="markDate"
              no="markDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:210px"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item :label="$t('Clearing.Annotator')">
            <cargo-advance-select
              no="userId"
              :select-type="selectTypeNames.basic_data_User"
              filterable
              :default-value="$store.getters.userId"
              :disabled="true"
              style="width:210px"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="primary" no="save" @click="saveEvent">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { signBilling } from '@/api/clearing/billingNative'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SignBillingDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    billingKeys: { type: Array, required: true } // 发票UUID
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      markDate: new Date()
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    saveEvent() {
      signBilling(this.billingKeys).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Marked'))
        this.$emit('update:visible', false)
        this.$emit('signBillingCallBack')
      }).finally(() => {
      })
    }
  }
}
</script>
<style lang="scss">
  .sign-billing-dialog {
    .el-form-item {
      margin: 0 auto;
      width: 300px;
      .el-form-item__content {
        width: 200px;
        .el-date-editor.el-input {
          width: 200px;
        }
      }
    }
  }
</style>
